import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect-form-page',
  templateUrl: './redirect-page.component.html',
  standalone: false
})
export class RedirectFormsPageComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const tab = this.route.snapshot.params['tab'];
    const url = tab ? `/benefits/allforms/${tab}` : '/benefits/allforms';

    this.router.navigate([url], {
      queryParamsHandling: 'preserve'
    });
  }
}
